module.exports = __webpack_public_path__ + "img/Rwanda.90424c65.png";